import { render, staticRenderFns } from "./TopPicks.vue?vue&type=template&id=7657e296&scoped=true"
import script from "./TopPicks.vue?vue&type=script&lang=js"
export * from "./TopPicks.vue?vue&type=script&lang=js"
import style0 from "./TopPicks.vue?vue&type=style&index=0&id=7657e296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7657e296",
  null
  
)

export default component.exports